<template>
    <div>
        <div class="position-relative">
            <!-- shape Hero -->
            <section class="section-shaped my-0">
                <div class="shape shape-style-1 shape-documentation">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div class=" h-100vh container container-lg shape-container d-flex">
                    <div class="mt-10 col px-0">
                        <div class="row">
                            <div class="col-lg-6">
                                <h1 class="display-3  text-white">API Documentation
                                    <span>is currently under construction</span>
                                </h1>
                                <p class="lead  text-white">This page will include detailed documentation for all of
                                    PlasticTwist's Crowdsourcing API endpoints.</p>
                                <div class="btn-wrapper">
                                    <router-link to="/" title="Docs">
                                        <base-button

                                                class="mb-3 mb-sm-0"
                                                type="ptwist">
                                            Back to the platform
                                        </base-button>
                                    </router-link>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <img src="../assets/img/ptwist_api_logo.png"
                                     class="img-fluid d-none d-md-block landing-logo">
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
export default {
  name: 'documentation',
  components: {}
}
</script>
